import Api from "./Api";
import {
  setLanguage1,
  setLanguage2,
  setLanguages,
  setLetterData,
  setLetters,
  setTopicData,
  setTopics,
  setUser,
} from "./store";
import { SONDER_LAUTE } from "../model/Config";
import { showToast } from "../helper/Toast";

const BASE_URL = "letters";
export const getAllData = async () => {
  try {
    let response = await Api.get(`${BASE_URL}`);
    if (response) {
      if (response.languages && response.languages.length) {
        let languages = response.languages.map(sLang=>{
          return {label:sLang,value:sLang}
        });
        setLanguages(languages);
        if (languages.length === 2) {
          setLanguage1(languages[0]);
          setLanguage2(languages[1]);
        }
      }

      
      handleLetters(response);
      handleTopics(response);

      if (response.user) {
        setUser(response.user);
      }
      return response;
    } else {
      // server error
      showToast("Could not contact Server", "ERROR");
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

function handleLetters(response) {
  let letterData = {};
  if (response.letters) {
    letterData = response.letters;
    letterData.forEach((l) => {
      l.data = l.letters;
      delete l.letters;
    });
    setLetterData(letterData);
    let allLetters = [];
    letterData.forEach((l) => {
      allLetters = allLetters.concat(l.data);
    });
    let letters = [];
    let doneLetters = [];
    allLetters.forEach((l) => {
      Object.keys(l).map((letter) => {
        let le = { value: letter, display: letter };
        if (SONDER_LAUTE.indexOf(letter) > -1) {
          //check if umlaut
          if (l[letter].displayLetter) {
            le.display = l[letter].displayLetter;
          }
        }
        if (doneLetters.indexOf(letter) === -1) {
          letters.push(le);
        }
        doneLetters.push(letter);
      });
    });
    setLetters(letters);
  }
}
function handleTopics(response) {
  if (response.topics) {
    let topics = { nature: [], culture: [], world: [] };
    response.topics.forEach((t) => {
      if (topics[t.preset]) {
        topics[t.preset].push({
          language: t.language,
          subtopic: t.subtopic,
          data: t.topics,
        });
      }
    });
    let topicLetters = { nature: [], culture: [], world: [] };

    // nature
    topicLetters.nature = topics.nature.map((t) => {
      return t.subtopic;
    });
    topicLetters.nature = topicLetters.nature.filter(onlyUnique);

    // culture
    topicLetters.culture = topics.culture.map((t) => {
      return t.subtopic;
    });
    topicLetters.culture = topicLetters.culture.filter(onlyUnique);

    // world
    topicLetters.world = topics.world.map((t) => {
      return t.subtopic;
    });
    topicLetters.world = topicLetters.world.filter(onlyUnique);

    setTopics(topicLetters);
    setTopicData(topics);
  }
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
